import { render } from "./MinipayViewAddress.vue?vue&type=template&id=bf8ebb0a&scoped=true&ts=true"
import script from "./MinipayViewAddress.vue?vue&type=script&lang=ts"
export * from "./MinipayViewAddress.vue?vue&type=script&lang=ts"

import "./MinipayViewAddress.vue?vue&type=style&index=0&id=bf8ebb0a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf8ebb0a"],['__file',"src/components/sell/MinipayViewAddress.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bf8ebb0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bf8ebb0a', __exports__)) {
    api.reload('bf8ebb0a', __exports__)
  }
  
  module.hot.accept("./MinipayViewAddress.vue?vue&type=template&id=bf8ebb0a&scoped=true&ts=true", () => {
    api.rerender('bf8ebb0a', render)
  })

}


export default __exports__